import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty'

import OIPricing from './OIPricing';
import OCPPricing from './OCPPricing';

export default function CoverageBlock({ isModified, rating, submission, pricingValues = {}, manuallySetPricing, isUnderwriter, ...extraProperty }) {
    const { type } = submission;

    const {
        [type]: {
            totalPremium = null,
            policyPremium = null,
            basePremium = null,
            totalExcessPremium = null,
            minimumEarnedPremium = null,
            bankPremium = null,
            additionalInsureds = null,
        },
        options = {},
    } = (rating || { oi: {}, ocp: {} })

    const limits = submission.ratings ? submission.ratings[submission.type].limits : {}
    const u653Deductible = submission.ratings ? submission.ratings[submission.type].u653Deductible : undefined;
    let ratingValues = {}
    if (manuallySetPricing || isEmpty(options)) {
        // If manually set price or knockout case
        ratingValues = pricingValues
    } else {
        ratingValues = Object.assign(options, { totalPremium, policyPremium, limits, basePremium, totalExcessPremium, minimumEarnedPremium, bankPremium, additionalInsureds, u653Deductible })
    }

    manuallySetPricing = isUnderwriter && manuallySetPricing

    if(ratingValues.minimumEarnedPremium == null || ratingValues.minimumEarnedPremium == undefined)
    {
        ratingValues = Object.assign(ratingValues,{minimumEarnedPremium: type==='oi' ? 25 : 100})
    }
    return (
        <div>
            { type === 'oi' && <OIPricing isModified={isModified} totalPremium={totalPremium} basePremium={basePremium} options={options} submission={submission} rating={rating} pricingValues={ratingValues} manuallySetPricing={manuallySetPricing} isUnderwriter={isUnderwriter} {...extraProperty} id="oiPricing" /> }
            { type === 'ocp' && <OCPPricing isModified={isModified} totalPremium={totalPremium} basePremium={basePremium} options={options} submission={submission} rating={rating} pricingValues={ratingValues} manuallySetPricing={manuallySetPricing} isUnderwriter={isUnderwriter} {...extraProperty} id="ocpPricing"  /> }
        </div>
    );
}
CoverageBlock.propTypes = {
    submission: PropTypes.object.isRequired
};
